import TextInput from "../../../components/TextInput/TextInput";
import Buttons from "../../../components/Buttons/Buttons";

const HPBasicInfoFields = ({
  formData,
  errors,
  isEditing,
  resetPassword,
  onChange,
  onResetPasswordClick,
}) => {
  return (
    <div className="hp-form-container_formdetails_container_section">
      <div className="hp-form-container_formdetails_container_section_input">
        <TextInput
          title="Name *"
          type="text"
          name="name"
          value={formData.name}
          onChange={onChange}
          placeholder="Enter your Name"
        />
        <span className="error">{errors.name}</span>
      </div>
      <div className="hp-form-container_formdetails_container_section_input">
        <TextInput
          title="User Name/Email *"
          type="email"
          name="emailId"
          value={formData.emailId}
          onChange={onChange}
          placeholder="Enter your Email"
        />
        <span className="error">{errors.emailId}</span>
      </div>
      {!isEditing && (
        <div className="hp-form-container_formdetails_container_section_input">
          <TextInput
            title="Password *"
            type="password"
            name="password"
            value={formData.password}
            onChange={onChange}
            placeholder="Enter Password"
          />
          <span className="error">{errors.password}</span>
        </div>
      )}
      {isEditing && (
        <div className="hp-form-container_formdetails_container_section_input">
          <div style={{ display: "flex", gap: "12px", alignItems: "flex-end" }}>
            <div style={{ flex: 1 }}>
              <TextInput
                title="Password *"
                type="password"
                name="password"
                value={resetPassword ? formData.password : "********"}
                onChange={onChange}
                placeholder={resetPassword ? "Enter new password" : "********"}
                disabled={!resetPassword}
              />
            </div>
            <Buttons
              text={resetPassword ? "Cancel" : "Reset"}
              type="button"
              variant="primary"
              onClick={onResetPasswordClick}
              style={{ width: "90px", height: "42px", flexShrink: 0 }}
            />
          </div>
          {errors.password && <span className="error">{errors.password}</span>}
        </div>
      )}
    </div>
  );
};

export default HPBasicInfoFields;
